import { ReactNode } from "react";
import { IconCheck } from "@tabler/icons-react";
import { cn } from "../lib/utils";

export default function AppCheckbox({
  checked,
  children,
  disabled = false,
  onChange,
  dataTestId,
}: {
  checked: boolean;
  children?: ReactNode;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  dataTestId?: string;
}): React.ReactElement {
  return (
    <div
      className={cn(
        "my-2 flex",
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      )}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
      data-testid={dataTestId}
    >
      {/* NOTE: Keep hidden checkbox element for screen readers */}
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        readOnly
        style={{ appearance: "none" }}
      />
      <div
        className={cn(
          "box-border flex size-[21px]  min-w-[21px] items-center justify-center me-2 border border-solid rounded-full select-none",
          checked
            ? "border-ds-primary bg-ds-primary"
            : "border-[#ccc] bg-transparent",
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        )}
      >
        {checked && <IconCheck className="size-3 text-white" stroke={3} />}
      </div>
      {children}
    </div>
  );
}
